import { connect } from "react-redux";
import PostSalesListing from "./postSalesListing";
import { bindActionCreators } from "redux";
import { getPostSaleListing } from "services/redux/sales/postSaleListing/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.postSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPostSaleListing,
      fetchZones,
      getListFilterData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostSalesListing);
